var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSketch = function SvgSketch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 21 3.208 10.952c-.609-.696-.913-1.044-1.04-1.439a2 2 0 0 1-.04-1.075c.096-.403.373-.773.928-1.513L5.04 4.28c.352-.47.528-.704.751-.873a2 2 0 0 1 .66-.33C6.72 3 7.013 3 7.6 3H12m0 18 8.792-10.048c.609-.696.913-1.044 1.04-1.439a2 2 0 0 0 .04-1.075c-.096-.403-.373-.773-.928-1.513L18.96 4.28c-.352-.47-.528-.704-.751-.873a2 2 0 0 0-.66-.33C17.28 3 16.987 3 16.4 3H12m0 18L8 9m4 12 4-12m-4-6L8 9m4-6 4 6M8 9h8M8 9H2.5M16 9h5.5"
  })));
};
export default SvgSketch;